import axios from "axios";

import type { TourResponse, UpdateTourDto } from "@optidev/shared-types";

import { createAuthHeaders } from "../api-client";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const tourApi = {
  /** Whether this user should see the editor tour, and which step to resume on. */
  async get(token: string): Promise<TourResponse> {
    const response = await axios.get(`${API_URL}/api/users/me/tour`, {
      headers: createAuthHeaders(token),
    });
    return response.data;
  },

  /**
   * Persist progress or end the tour.
   *
   * Fire and forget at every call site: the tour is bookkeeping, and making the
   * user wait on a round trip to move between steps would be worse than losing a
   * step index on a dropped request.
   */
  async update(token: string, dto: UpdateTourDto): Promise<TourResponse> {
    const response = await axios.patch(`${API_URL}/api/users/me/tour`, dto, {
      headers: createAuthHeaders(token),
    });
    return response.data;
  },
};
